import { render } from "./icon.vue?vue&type=template&id=e665d05c"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e665d05c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e665d05c', __exports__)) {
    console.log('reload')
    api.reload('e665d05c', __exports__)
  }
  
  module.hot.accept("./icon.vue?vue&type=template&id=e665d05c", () => {
    console.log('re-render')
    api.rerender('e665d05c', render)
  })

}


export default __exports__